<template>
  <div
    :class="[
      $style.container,
      computedClasses,
      { [$style.lastInForm]: lastInForm },
    ]"
    @click.self="handleFocus"
  >
    <span
      v-if="$slots.hasOwnProperty('icon-left')"
      :class="[$style.icon, $style.left]"
      @click="selectOnInput"
    >
      <slot name="icon-left" />
    </span>
    <component
      :is="currentComponent"
      :ref="getInputRef"
      :type="type"
      :placeholder="placeholder"
      :maxlength="maxlength"
      :disabled="disabled"
      :value="value"
      @input="handleInput"
      @focus="handleFocus"
      @blur="handleBlur"
      @submit="handleSubmit"
    />
    <span
      v-if="$slots.hasOwnProperty('icon-right')"
      :class="[$style.icon, $style.right]"
    >
      <slot name="icon-right" />
    </span>
  </div>
</template>

<script>
import inputMixin from 'lib/mixins/inputMixin';

import BaseInput from 'atoms/base/BaseInput';
import BaseTextarea from 'atoms/base/BaseTextarea';

export default {
  name: 'SimpleInput',
  mixins: [
    inputMixin,
  ],
  components: {
    BaseInput,
    BaseTextarea,
  },
  props: {
    lastInForm: Boolean,
  },
  computed: {
    currentComponent() {
      return this.type === 'textarea' ? BaseTextarea : BaseInput;
    },
  },
};

</script>

<style lang="sass" module>
  .container
    +simple-input

  .icon
    +icon-to-simple-input
</style>
